export const token = localStorage.getItem('token');
export const user = JSON.parse(localStorage.getItem('user'));
// export const userId = user._id;
